[
    'da',
    'en',
    'fr',
    'nl',
    'de'
].forEach(function(lang) {
    module.exports[lang] = require('./lang/'+lang);
});